export { default as ProductsIndexPageCategoriesNavAmountButton } from './ProductsIndexPageCategoriesNavAmountButton';
